<template>
    <b-modal v-model="show" :title="$t('auto.taxesAdd')" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Тури <span class="red">*</span></label>
                        <select class="form-control" v-model="autoGasPriceDto.gasDeviceType" :class="{invalid : $v.autoGasPriceDto.gasDeviceType.$error}">
                            <option value="METHANE">МЕТАН</option>
                            <option value="PROPANE">ПРОПАН</option>
                        </select>
                        <div class="red" v-if="$v.autoGasPriceDto.gasDeviceType.$error">Тури</div>
                    </div>
<!--                    <div class="form-group">-->
<!--                        <label>Сиғими <span class="red">*</span></label>-->
<!--                        <select class="form-control" v-model="autoGasPriceDto.capacity" :class="{invalid : $v.autoGasPriceDto.capacity.$error}">-->
<!--                            <option value="30">30 Л</option>-->
<!--                            <option value="50">50 Л</option>-->
<!--                            <option value="60">60 Л</option>-->
<!--                            <option value="65">65 Л</option>-->
<!--                            <option value="75">75 Л</option>-->
<!--                            <option value="80">80 Л</option>-->
<!--                            <option value="90">90 Л</option>-->
<!--                            <option value="100">100 Л</option>-->
<!--                        </select>-->
<!--                        <div class="red" v-if="$v.autoGasPriceDto.capacity.$error">Сиғими</div>-->
<!--                    </div>-->
                    <div class="form-group">
                        <label>Сиғими <span class="red">*</span></label>
                        <numeric-input v-model="autoGasPriceDto.capacity" :precision="2" :class="{invalid : $v.autoGasPriceDto.capacity.$error}"></numeric-input>
                    </div>
                  <div class="form-group">
                        <label>Нархи <span class="red">*</span></label>
                        <numeric-input v-model="autoGasPriceDto.price" :precision="2" :class="{invalid : $v.autoGasPriceDto.price.$error}"></numeric-input>
                    </div>
                    <div class="red" v-if="$v.autoGasPriceDto.price.$error">Нархи</div>

                    <div class="form-group">
                        <label>Манба <span class="red">*</span></label>
                        <input type="text" class="form-control" v-model="autoGasPriceDto.source"
                               :class="{invalid : $v.autoGasPriceDto.source.$error}"/>
                    </div>
                    <div class="red" v-if="$v.autoGasPriceDto.source.$error">Манба</div>

                    <div class="form-group">
                        <template>
                            <DropZone code="autoDevicePriceListDropZone"
                                      folder="Settings"
                                      subFolder="AutoDevicePriceList"
                                      acceptedFiles="image/*"
                                      label="Прайс лист"
                                      :data="autoGasPriceDto.autoDevicePriceList"
                                      @change="(files) => {autoGasPriceDto.autoDevicePriceList = files}"
                            />
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" v-if="!autoGasPriceDto.id">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import {numericTypes} from '@/shared/constants/mask'
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import { required, minLength } from 'vuelidate/lib/validators'
    import DropZone from '@/views/dropZone/DropZone'

    export default {
        name: "GasDevicePriceAddView",
        components: {
            'b-modal': bModal,
            DropZone
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                autoGasPriceDto: {
                    id: null,
                    gasDeviceType: null,
                    capacity: null,
                    price: null,
                    source: null,
                    autoDevicePriceList: []
                }
            }
        },
        validations: {
            autoGasPriceDto: {
                gasDeviceType: {
                    required
                },
                price: {
                    required
                },
                capacity: {
                    required
                },
                source: {
                    required
                },
                autoDevicePriceList: {
                    required: required,
                    minLength: minLength(1)
                }
            }
        },
        methods: {
            cancel() {
                this.show = false;
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;
                this.processing = true;

                this.$http.post('auto-gas-price/save', this.autoGasPriceDto)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('gasPriceChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            const vm = this;
            this.$eventBus.$on('showGasPriceAdd', (data) => {
                if (data) {
                    vm.autoGasPriceDto = data;
                } else {
                    vm.autoGasPriceDto = {
                        id: null,
                            gasDeviceType: null,
                            price: null,
                            source: null,
                            autoDevicePriceList: []
                    }
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>